import { LicenseInfo } from '@mui/x-license';

// Use environment variable if available, otherwise use a fallback (for development only)
const licenseKey =
	process.env.REACT_APP_MUI_X_LICENSE_KEY || 'YOUR_LICENSE_KEY';
LicenseInfo.setLicenseKey(licenseKey);

export default function MuiXLicense() {
	return null;
}
